webpackJsonp([98060378072551],{

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ProjectPage = __webpack_require__(9);
	
	var _ProjectPage2 = _interopRequireDefault(_ProjectPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import SinglePicsPage from '../components/SinglePics'
	
	
	var projectElements = {
		images: [{
			"src": "DigitalCollage/Street_Walker",
			"orientation": "portrait"
		}, {
			"src": "DigitalCollage/Spaceship_Jumpers",
			"orientation": "portrait"
		}, {
			"src": "DigitalCollage/Freedom_of_Waiting",
			"orientation": "portrait"
		}, {
			"src": "DigitalCollage/Dessert_Hike",
			"orientation": "portrait"
		}, {
			"src": "DigitalCollage/Underwater_World",
			"orientation": "portrait"
		}, {
			"src": "DigitalCollage/Love_Hate_Relationship",
			"orientation": "portrait"
		},
		//"src": "DigitalCollage/Reflections_of_Phantasy",
		//"orientation": "portrait"
		//},
		{
			"src": "DigitalCollage/Inbetween_Worlds",
			"orientation": "portrait"
		}, {
			"src": "DigitalCollage/Bedtime_Story",
			"orientation": "portrait"
		}]
	};
	
	var CollagePage = function (_React$Component) {
		_inherits(CollagePage, _React$Component);
	
		function CollagePage() {
			_classCallCheck(this, CollagePage);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		CollagePage.prototype.render = function render() {
			return _react2.default.createElement(_ProjectPage2.default, {
				title: 'Digital Collage',
				text: 'Schon in meiner Schulzeit habe ich an Papier-Collagen gearbeitet. Im Jahr 2019 habe ich begonnen die Technik der Collage  im Digitalen einzusetzen. Mittlerweile habe ich an mehreren digitalen Collagen gearbeitet. Das verwendete Bildmaterial der Collagen stammt von Unsplash.',
				images: projectElements.images,
				layout: 'zweier' });
		};
	
		return CollagePage;
	}(_react2.default.Component);
	
	exports.default = CollagePage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-collage-js-f41830a8bc07a0c3c229.js